/**
 * Tabs の props。
 */
export interface TabsProps {
  /** 切り替えるタブ */
  items: readonly { id: string; label: string }[];
  /** 選択中のタブ */
  selected: string;
  /** タブを選んだときに呼ばれる */
  onSelect: (id: string) => void;
  /** 読み上げ用の説明 */
  label: string;
}

/**
 * @graph-stack ado-task
 * @graph-domain Finance
 * @graph-business 画面の中身を切り替えるタブ。種別の絞り込みタブと同じ見た目にして、操作の意味が同じものは同じ形に見えるようにする
 * @graph-connects none
 */
export function Tabs({ items, selected, onSelect, label }: TabsProps) {
  const tabClass = (active: boolean): string =>
    active
      ? 'relative -mb-px rounded-t border border-b-0 border-[var(--color-border-subtle)] bg-[var(--color-bg-surface)] px-3 py-1.5 text-sm font-medium text-[var(--color-text-primary)]'
      : 'rounded-t border border-transparent px-3 py-1.5 text-sm text-[var(--color-text-secondary)] hover:bg-[var(--color-bg-subtle)] hover:text-[var(--color-text-primary)]';

  return (
    <div
      role="tablist"
      aria-label={label}
      className="flex flex-wrap items-end gap-1 border-b border-[var(--color-border-subtle)]"
    >
      {items.map((item) => (
        <button
          key={item.id}
          type="button"
          role="tab"
          aria-selected={selected === item.id}
          onClick={() => {
            onSelect(item.id);
          }}
          className={tabClass(selected === item.id)}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
}
